import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@nosible/shared/components/ui/card";
import { Button } from "@nosible/shared/components/ui/button";
import { Alert, AlertDescription } from "@nosible/shared/components/ui/alert";
import { trpc } from "@/admin/lib/trpc";
import { AuthSyncCard } from "@/admin/components/admin/sync/AuthSyncCard";
import { UsageSyncCard } from "@/admin/components/admin/sync/UsageSyncCard";
import { SubscriptionAuthSyncTable } from "@/admin/components/admin/sync/SubscriptionAuthSyncTable";
import {
  Database,
  CheckCircle2,
  Loader2,
  AlertCircle,
} from "lucide-react";

export function AdminRedisSync() {
  const testConnection = trpc.admin.sync.testConnection.useMutation();


  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold font-display flex items-center gap-2"><Database className="h-7 w-7 text-violet-pulse" />Redis Sync Monitor</h1>
          <p className="text-muted-foreground mt-1">
            Monitor and control synchronization between PostgreSQL and Redis
          </p>
        </div>
        <Button
          variant="outline"
          onClick={() => testConnection.mutate()}
          disabled={testConnection.isPending}
          className="border-chromium-mist/20"
        >
          {testConnection.isPending ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Testing...
            </>
          ) : (
            <>
              <Database className="mr-2 h-4 w-4" />
              Test Redis Connection
            </>
          )}
        </Button>
      </div>

      {testConnection.isSuccess && (
        <Alert className="bg-neon-green/10 border-neon-green">
          <CheckCircle2 className="h-4 w-4 text-neon-green" />
          <AlertDescription className="text-neon-green">
            ✓ {testConnection.data.message} ({testConnection.data.responseTimeMs}ms)
          </AlertDescription>
        </Alert>
      )}

      {testConnection.isError && (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>
            {testConnection.error.message}
          </AlertDescription>
        </Alert>
      )}

      <div className="grid gap-6 lg:grid-cols-2">
        <AuthSyncCard hasPermission={true} />
        <UsageSyncCard hasPermission={true} />
      </div>

      <SubscriptionAuthSyncTable hasPermission={true} />
    </div>
  );
}
